import { Link } from "react-router-dom";
import {
  createUserWithEmailAndPassword,
  FacebookAuthProvider,
  GoogleAuthProvider,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineMail } from "react-icons/ai";
import { CgProfile } from "react-icons/cg";
import { FaFacebookF } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { RiLockPasswordLine } from "react-icons/ri";
import * as Yup from "yup";
import { auth, db } from "../../shared/firebase";
import { signInWithProvider } from "./SignInWithProvider";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { convertErrorCodeToMessage } from "../../shared/utils";
import toast from "react-hot-toast";

const SignUp = ({ setIsSignIn, isSignIn }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const signUpHandler = async (values) => {
    try {
      setIsLoading(true);
      const user = (
        await createUserWithEmailAndPassword(
          auth,
          values.email,
          values.password
        )
      ).user;

      setDoc(doc(db, "users", user.uid), {
        firstName: values.firstName,
        lastName: values.lastName,
        photoUrl: "https://cutt.ly/73pqhgS",
        watchlist: [],
        recentlyWatch: [],
      });

      toast("You're registered successfully!", {
        icon: "👏",
      });
      setTimeout(() => {
        navigate("/");
      }, 5000);
      setIsLoading(false);
    } catch (error) {
      const errorMessage = convertErrorCodeToMessage(error.code);
      toast(errorMessage, {
        icon: "😧",
      });
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && (
        <div className="flex justify-center items-center z-10 h-screen relative">
          <div className="w-28 h-28 border-[10px] rounded-full border-primary border-t-transparent animate-spin "></div>
        </div>
      )}
      <div className="p-3 sm:p-6 w-full h-full md:max-w-[60vw] lg:max-w-[40vw] absolute top-1/2 -translate-y-1/2 right-0 md:bg-dark-darken">
        <div className="flex flex-col mb-8 font-semibold mx-auto">
          <div className="flex items-center mr-auto mb-8 sm:mb-4">
            <Link to="/" className="pt-3 mr-5 md:hidden">
              <LazyLoadImage
                alt="Logo"
                src="/logoicon.png"
                effect="opacity"
                className="w-12 h-12"
              />
            </Link>
            <div className="font-semibold">
              <div className="uppercase tracking-wider text-xl font-medium mb-1">
                Start for free
              </div>
              <div className="text-primary leading-none text-3xl md:text-3xl">
                Create an account
              </div>
            </div>
          </div>
          <div className="flex gap-4 mb-4">
            <button
              className="h-12 w-12 rounded-full bg-white flex justify-center items-center brightness-90 hover:scale-110 hover:brightness-110 transition duration-300"
              onClick={() =>
                signInWithProvider(new GoogleAuthProvider(), "google")
              }
            >
              <FcGoogle size={25} />
            </button>
            <button
              className="h-12 w-12 rounded-full bg-white flex justify-center items-center brightness-90 hover:scale-110 hover:brightness-110 transition duration-300 bg-[#1778F2]"
              onClick={() =>
                signInWithProvider(new FacebookAuthProvider(), "facebook")
              }
            >
              <FaFacebookF size={25} color="white" />
            </button>
          </div>
          <p className="text-lg">or use your email account </p>
        </div>

        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
            password: "",
          }}
          validationSchema={Yup.object({
            firstName: Yup.string()
              .max(20, "Must be 20 characters or less")
              .required("Required"),
            lastName: Yup.string()
              .max(20, "Must be 20 characters or less")
              .required("Required"),
            email: Yup.string()
              .email("Invalid email address")
              .required("Required"),
            password: Yup.string()
              .required("No password provided.")
              .min(6, "Password is too short - should be 6 chars minimum."),
          })}
          onSubmit={signUpHandler}
        >
          <Form>
            <div className="flex justify-between mb-6 gap-2">
              <div className="relative">
                <Field
                  name="firstName"
                  type="text"
                  placeholder="First name"
                  className="w-full bg-dark-lighten px-5 py-4 pr-12 rounded-xl outline-none peer text-white"
                />
                <label
                  htmlFor="firstName"
                  className={`absolute left-5 text-gray-400 transition duration-500 pointer-events-none 
                translate-y-[-50%] visible peer-placeholder-shown:opacity-0 peer-placeholder-shown:invisible peer-placeholder-shown:translate-y-[-10%] ease-in-out
                `}
                >
                  First name
                </label>
                <CgProfile
                  size={25}
                  className="absolute top-1/2 -translate-y-1/2 right-4"
                />
                <p className="absolute top-[95%] left-[3%] text-primary">
                  <ErrorMessage name="firstName" />
                </p>
              </div>

              <div className="relative">
                <Field
                  name="lastName"
                  type="text"
                  placeholder="Last name"
                  className="w-full bg-dark-lighten px-5 py-4 pr-12 rounded-xl outline-none peer text-white"
                />
                <label
                  htmlFor="lastName"
                  className={`absolute left-5 text-gray-400 transition duration-500 pointer-events-none 
                translate-y-[-50%] visible peer-placeholder-shown:opacity-0 peer-placeholder-shown:invisible peer-placeholder-shown:translate-y-[-10%] ease-in-out
                `}
                >
                  Last name
                </label>
                <CgProfile
                  size={25}
                  className="absolute top-1/2 -translate-y-1/2 right-4"
                />
                <p className="absolute top-[95%] left-[3%] text-primary">
                  <ErrorMessage name="lastName" />
                </p>
              </div>
            </div>
            <div className="relative mb-6">
              <Field
                name="email"
                type="email"
                placeholder="Email"
                className="w-full bg-dark-lighten px-5 py-4 pr-12 rounded-xl outline-none peer text-white"
              />
              <label
                htmlFor="email"
                className={`absolute left-5 text-gray-400 transition duration-500 pointer-events-none 
                translate-y-[-50%] visible peer-placeholder-shown:opacity-0 peer-placeholder-shown:invisible peer-placeholder-shown:translate-y-[-10%] ease-in-out
                `}
              >
                Email
              </label>
              <AiOutlineMail
                size={25}
                className="absolute top-1/2 -translate-y-1/2 right-4"
              />
              <p className="absolute top-[95%] left-[3%] text-primary">
                <ErrorMessage name="email" />
              </p>
            </div>
            <div className="relative mb-12">
              <Field
                name="password"
                type="password"
                placeholder="Password"
                className="w-full bg-dark-lighten px-5 py-4 pr-12 rounded-xl outline-none peer text-white"
              />
              <label
                htmlFor="password"
                className={`absolute left-5 text-gray-400 transition duration-500 pointer-events-none 
                translate-y-[-50%] visible peer-placeholder-shown:opacity-0 peer-placeholder-shown:invisible peer-placeholder-shown:translate-y-[-10%] ease-in-out
                `}
              >
                Password
              </label>
              <RiLockPasswordLine
                size={25}
                className="absolute top-1/2 -translate-y-1/2 right-4"
              />
              <p className="absolute top-[95%] left-[3%] text-primary">
                <ErrorMessage name="password" />
              </p>
            </div>
            <button
              className="flex justify-center items-center px-12 py-3 rounded-full text-lg text-white
              bg-gradient-to-br from-primary via-red-700 to-orange-600 uppercase tracking-wider absolute left-1/2 -translate-x-1/2 group hover:scale-105 transition duration-500"
            >
              Register
            </button>
          </Form>
        </Formik>
        <p className="text-xl flex gap-2 mt-32 justify-center">
          <span>Already a member?</span>
          <button
            type="submit"
            onClick={() => setIsSignIn(!isSignIn)}
            className="text-red-600 transition duration-300 hover:underline hover:underline-offset-2"
          >
            Sign In
          </button>
        </p>
      </div>
    </>
  );
};

export default SignUp;
